import type { IAvailabilityOverride, IAvailabilityOverrideInput } from '@torim-app/types';
import { adminUrlBuilder } from '@app/api/utils';

export class AvailabilityOverridesApi {
  static readonly path = 'availability/overrides';

  static async list(): Promise<IAvailabilityOverride[]> {
    const url = adminUrlBuilder({}, AvailabilityOverridesApi.path);
    const res = await fetch(url, {
      method: 'get',
      headers: { 'content-type': 'application/json' },
    });
    if (!res.ok) throw 'Failed to fetch availability overrides';
    return res.json();
  }

  static async create(body: IAvailabilityOverrideInput): Promise<IAvailabilityOverride> {
    const url = adminUrlBuilder({}, AvailabilityOverridesApi.path);
    const res = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw 'Failed to create availability override';
    return res.json();
  }

  static async update(id: string, body: IAvailabilityOverrideInput): Promise<IAvailabilityOverride> {
    const url = adminUrlBuilder({}, `${AvailabilityOverridesApi.path}/${id}`);
    const res = await fetch(url, {
      method: 'put',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw 'Failed to update availability override';
    return res.json();
  }

  static async remove(id: string): Promise<void> {
    const url = adminUrlBuilder({}, `${AvailabilityOverridesApi.path}/${id}`);
    const res = await fetch(url, {
      method: 'delete',
      headers: { 'content-type': 'application/json' },
    });
    if (!res.ok) throw 'Failed to delete availability override';
  }
}
